/**
 * Format French phone number with groups of two digits.
 *
 * @param value - Phone to format
 * @returns French-formatted 06 or +336 number
 */
export const formatPhone = (value: string) => {
    if (value.startsWith("0")) {
        return value.replace(/^(.{2})(.{2})(.{2})(.{2})(.*)$/, "$1\xa0$2\xa0$3\xa0$4\xa0$5")
    }

    return value.replace(/^(.{3})(.{1})(.{2})(.{2})(.{2})(.*)$/, "$1\xa0$2\xa0$3\xa0$4\xa0$5\xa0$6")
}
